module.exports = __webpack_public_path__ + "static/img/HomePlaying@3x.e862b77.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/images/UI_mock/3x/HomePlaying@3x.png
// module id = y6NO
// module chunks = 1